import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const StyledModalHeading = styled.div`
  padding: 0;
  margin: 24px;
  font-size: 24px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  line-height: 1.2;
  font-weight: 600;
`;
